import React, { useEffect } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";
import VideoPlayer from "../components/VideoPlayer/VideoPlayer.js";

import { useNavigateWithVars } from "../hooks/useNavigateWithVars";
const Page = (props) => {
  const rules = useStore((state) => state.rules);
  const game = useStore((state) => state.game);
  const navigateTo = useNavigateWithVars();

  const fetchRules = useStore((state) => state.fetchRules);

  useEffect(() => {
    if (!rules) fetchRules();
  }, []);

  useEffect(() => {
    console.log("Rules", rules);
  }, [rules]);

  const replaceRound = () => {
    const paragraphs = rules.RundenzahlRegel.map((p) => {
      const text = rules.RundenzahlRegel[0].children.map((child) => {
        return {
          ...child,
          text: child.text.replace("%RUNDEN%", game.Rounds),
        };
      });
      // console.log("Text", text);
      return {
        ...p,
        children: text,
      };
    });
    // console.log("Paragraphs", paragraphs);
    return <BlocksRenderer content={paragraphs} />;
  };

  if (rules === null || game === null) return null;
  return (
    <div
      className={`Page Rules${props.className ? " " + props.className : ""}`}
    >
      <h1>{rules?.Headline}</h1>
      <ul className="RulesList">
        <li className="Rule">{replaceRound()}</li>
        {rules?.Regeln?.map((rule, index) => {
          // console.log("Rule", rule);
          if (rule.__component === "blocks.text-block")
            return (
              <li className="Rule" key={index}>
                <BlocksRenderer content={rule.text} />
              </li>
            );
          if (
            rule.__component === "blocks.media-block" &&
            rule.media.data?.attributes?.mime.includes("video")
          )
            return (
              <li className="Rule" key={index}>
                <VideoPlayer
                  url={
                    process.env.REACT_APP_CMS_URL +
                    rule.media?.data?.attributes?.url
                  }
                />
                <BlocksRenderer content={rule.mediaText} />
              </li>
            );

          if (
            rule.__component === "blocks.media-block" &&
            rule.media.data?.attributes?.mime.includes("audio")
          )
            return (
              <li className="Rule" key={index}>
                <AudioPlayer
                  url={
                    process.env.REACT_APP_CMS_URL +
                    rule.media?.data?.attributes?.url
                  }
                  transcript={rule.mediaText || null}
                />
              </li>
            );
        })}
      </ul>

      {props.children}
    </div>
  );
};

export default Page;
